import { render, staticRenderFns } from "./notesPopup.vue?vue&type=template&id=34fb573e"
import script from "./notesPopup.js?vue&type=script&lang=js&external"
export * from "./notesPopup.js?vue&type=script&lang=js&external"
import style0 from "./notesPopup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports